import React, { useState } from 'react'
import { Magnifier } from 'react-image-magnifiers'
import Lightbox from 'react-image-lightbox'
import 'react-image-lightbox/style.css'
import { isEmpty } from 'lodash'

function Media(props) {
  const { product, gallery, adClass = "product-gallery-vertical" } = props

  const [ photoIndex, setPhotoIndex ] = useState( 0 )
  const [ isOpen, setStatus ] = useState( false )

  const bigImages = gallery
  const smallImages = gallery

  function openLightBox() {
    let index = parseInt( document.querySelector( ".product-main-image" ).getAttribute( "index" ) )

    if ( !index ) {
      index = 0;
    }
    setStatus( true )
    setPhotoIndex( index )
  }

  function closeLightBox() {
    setStatus( false )
  }

  const setNextHandler = () => {
    window.analytics.track("[PDP] Click to next photo", { product })
    setPhotoIndex( photoIndex => ( photoIndex + 1 ) % bigImages.length )
  }

  const setPrevHandler = () => {
    window.analytics.track("[PDP] Click to previous photo", { product })
    setPhotoIndex( photoIndex => ( photoIndex + bigImages.length - 1 ) % bigImages.length )
  }

  const downloadPicture = () => {
    window.analytics.track("Product Image Downloaded", { product: {
        productName: product.name,
        productId: product.id,
        productCode: product.code,
        providerName: product.supplier.nombreComercial,
        family: product.familyId,
        category: product.categoryID,
        subcategory: product.subcategoryId,
        retailPrice: product.retailPrice,
        description: product.description 
    }, photo: gallery[photoIndex]})

    window.open(gallery[photoIndex], '_blank', 'noopener,noreferrer')
  }

  return (
    <>
      {!isEmpty(gallery) && (
        <div className={ `product-gallery ${adClass}` }>
          <div className="row m-0">
            <figure className="product-main-image" index="0">
              <div id="btn-product-gallery" className="btn-download-picture" onClick={downloadPicture}>
                <i className="mdi mdi-download"></i>
              </div>
              { product.status.codeName === 'NO_DISPONIBLE' ? <span className="product-label label-primary">Producto No Disponible</span> : '' }
              <Magnifier
                imageSrc={gallery[photoIndex]}
                imageAlt="Imagenes del producto"
                dragToMove={ false }
                mouseActivation="hover"
                cursorStyleActive="crosshair"
                id="product-zoom"
              />
              <div id="btn-product-gallery" className="btn-product-gallery" onClick={openLightBox}>
                <i className="mdi mdi-arrow-expand-all"></i> 
              </div>
            </figure>

            <div id="product-zoom-gallery" className="product-image-gallery">
              {
                gallery.map((item, index) =>
                  <div
                    className={ `product-gallery-item ${photoIndex === index ? 'active' : ''}` }
                    to="#" data-image={ item }
                    data-zoom-image={ bigImages[ index ] }
                    key={ item.id + '-' + index }
                    onClick={() => {
                        setPhotoIndex(index)
                        window.analytics.track("Product thumbnail viewed")
                    }}
                  >
                    <img src={smallImages[index]} alt="product back" />
                  </div>
                )
              }
            </div>
          </div>
        </div>
      )}
      {isOpen && (
        <Lightbox
          mainSrc={bigImages[ photoIndex ]}
          nextSrc={bigImages[ ( photoIndex + 1 ) % bigImages.length ]}
          prevSrc={bigImages[ ( photoIndex + bigImages.length - 1 ) % bigImages.length ]}
          onCloseRequest={ closeLightBox }
          onMovePrevRequest={ setNextHandler }
          onMoveNextRequest={ setPrevHandler }
        />)
      }
    </>
  )
}

export default Media
